export const safeStringCompare: (string1?: string, string2?: string) => boolean = (
  string1,
  string2
) => {
  if (!string1 || !string2) {
    return false;
  } else if (string1.length !== string2.length) {
    return false;
  }

  let mismatch = 0;
  for (let i = 0; i < string1.length; i++) {
    // eslint-disable-next-line no-bitwise
    mismatch |= (string1.charCodeAt(i) ^ string2.charCodeAt(i));
  }

  return mismatch === 0;
};
